import Model, { attr } from '@ember-data/model';

interface Amount {
  currency: string;
  value: string;
}

interface PaymentInitiator {
  resourceId: string;
  resourceType: PaymentLinkType;
  resourceNumber?: string;
}

interface Settings {
  redirectUrl?: string;
  reusable?: boolean;
}

interface Item {
  id: string;
  title: string;
  type?: 'good' | 'service';
  description?: string;
  quantity: number;
  measureUnit?: string;
  unitPrice: Amount;
  vatRate: string;
}

type PaymentLinkStatus = 'paid' | 'open' | 'expired' | 'canceled';
type PaymentLinkType = 'Basket' | 'Invoice';
type PaymentMethod = 'credit_card' | 'apple_pay' | 'paypal' | 'ideal' | 'bank_transfer';

export default class PaymentLinkModel extends Model {
  @attr('hash') declare amount: Amount;
  @attr('string') declare latestPaymentMethod?: string;
  @attr('string') declare debitorName?: string;
  @attr('hash') declare paymentInitiator: PaymentInitiator;
  @attr('string') declare status: PaymentLinkStatus;
  @attr() declare potentialPaymentMethods: PaymentMethod[];
  @attr('hash') declare settings?: Settings;
  @attr('string') declare expirationDate: string;
  @attr('string') declare organizationName?: string;
  @attr('string') declare name: string;
  @attr('hash') declare items?: Item[];
  @attr('string') declare profileId: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'payment-link': PaymentLinkModel;
  }
}
